// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6997":"5bbc9d93777f48c7","7453":"6987f49724b7e0d7","8385":"526ed7327820e36d"}[chunkId] + ".js";
};